import React, { useState } from "react";
import SFTypography from "../../../typography";
import { SFGridContainer, SFGridItem, SFStack } from "../../../grid";
import { SFArrowUpIcon, SFArrowDownIcon } from "../../../icons";
import SFIconButton from "../../../button/iconButton";
import getStyled from "../../../../hooks/getStyled";
import SFAuthorized from "../../../authorized";

const { styled } = getStyled();

const SFIconButtonStyled = styled(SFIconButton)(() => ({
  marginLeft: -14,
}));

const SFMasterDetailCellRenderer = (props) => {
  const [rowExpanded, setRowExpanded] = useState(false);

  const toggleMasterDetails = () => {
    setRowExpanded((curState) => !curState);
    if (!props.context.allowMultipleDetailRows) {
      props.api.forEachNode((node) => node.setExpanded(false));
    }
    props.node.setExpanded(!rowExpanded);
  };

  return (
    <SFGridContainer spacing={0}>
      <SFGridItem xs={12}>
        <SFAuthorized permissions={props.context.permissions?.viewDetails}>
          <SFIconButtonStyled onClick={toggleMasterDetails}>
            <SFStack direction="row" alignItems="center" spacing={1}>
              {rowExpanded ? (
                <SFArrowUpIcon color="primary" />
              ) : (
                <SFArrowDownIcon color="primary" />
              )}
              <SFTypography variant="tableList">
                {props.data[props.colDef.field]}
              </SFTypography>
            </SFStack>
          </SFIconButtonStyled>
        </SFAuthorized>
      </SFGridItem>
    </SFGridContainer>
  );
};

export default SFMasterDetailCellRenderer;
